import classnames from 'classnames';
import React, { FC } from 'react';
import { CloseButton, IconButton } from '../../index';
import { ActionButtonSkin, IItemActionButtonOuter } from '../ItemActionsRow.types';

import styles from './ItemActionButton.scss';

export const ItemActionButton: FC<IItemActionButtonOuter> = ({
  skin = ActionButtonSkin.Dark,
  className,
  isIcon = false,
  dataHook,
  onClick,
  children,
}) => {
  switch (skin) {
    case ActionButtonSkin.Light:
      return (
        <IconButton
          className={classnames(styles.actionButton, {
            [styles.iconButton]: isIcon,
          })}
          size="small"
          skin="standard"
          priority="secondary"
          dataHook={dataHook}
          onClick={onClick}
        >
          {children}
        </IconButton>
      );

    case ActionButtonSkin.Dark:
    default:
      return (
        <CloseButton
          size="medium"
          skin="lightFilled"
          className={classnames(styles.darkerBackground, styles.actionButton, className, {
            [styles.iconButton]: isIcon,
          })}
          dataHook={dataHook}
          onClick={onClick}
        >
          {children}
        </CloseButton>
      );
  }
};
